module.exports = __webpack_public_path__ + "img/img2.26a095d1.png";